import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from "@fortawesome/pro-solid-svg-icons/faSync";

export const SyncIndicator: React.FC<{}> = (props) => (
    <FontAwesomeIcon
        fixedWidth
        spin={true}
        icon={faSync}
        style={{ fontSize: "0.775em" }}
    />
);
